import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GemsHttpService } from './gems-http.service';
import { Observable, of } from 'rxjs';
import { isEmpty, find } from 'lodash';
import { CacheService } from 'client/app/shared/services/cache';
import { catchError, map, take, tap } from 'rxjs/operators';
import { ISitemap, IUserProfile, ManagedContent } from '@neb/lit-storybook';
import { EnumCacheKeys, EnumInjectionTokens, IEnumCacheKeys } from '../constants';
import { IEnvironment } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class GemsService {
  get controller() { return `${this.environment.base.apiUrl}/Gems`; }

  static getContentByContentId(contents: any, contentId: string) {
    const contentItem = find(contents, { 'contentid': contentId });
    let content = '';
    if (!isEmpty(contentItem)) content = contentItem.content;
    return content;
  }

  constructor(
    private gemsHttp: GemsHttpService,
    private httpClient: HttpClient,
    private cacheService: CacheService,
    @Inject(EnumInjectionTokens.Environment) private environment: IEnvironment
  ) { }

  loadContent(pageAlias: string, helpTextAliases?: IEnumCacheKeys) {
    const content: any = this.cacheService.get(helpTextAliases);

    if (!isEmpty(content)) return of(content)

    const url = `${this.controller}/managedContent`;
    const params = new HttpParams()
      .append('pageAlias', pageAlias)
      .append('helpTextAliases', helpTextAliases)

    return this.gemsHttp.get(url, { params }).pipe(
      tap(x => this.cacheService.set(helpTextAliases, x)),
      catchError((val: HttpErrorResponse) => {
        console.log(`GemsService.loadContent error: ${val.message}`);
        return of([]);
      })
    )
  }

  getBannerAlerts() {
    const params = new HttpParams()
      .append('pageAlias', 'RetirementPlanDocuments')

    const url = `${this.controller}/managedContent`;

    return  this.httpClient.get<ManagedContent>(url, { params }).pipe(
      map((res: ManagedContent) => res?.banners || []),
      catchError((val: HttpErrorResponse) => {
        console.log(`GemsService.getAlerts error: ${val.message}`);
        return of([]);
      })
    )
  }

  siteMap(): Observable<ISitemap> {
    const sitemap = this.cacheService.get<ISitemap>(EnumCacheKeys.RC_PPT_SITE_MAP);

    if (sitemap) return of(sitemap);

    return this.httpClient.get<ISitemap>(`${this.controller}/sitemap`).pipe(  
      take(1),
      tap(res => this.cacheService.set(EnumCacheKeys.RC_PPT_SITE_MAP, res)),
      catchError((val: HttpErrorResponse) => {
        console.log(`GemsService.siteMap error: ${val.message}`);
        return of({} as ISitemap);
      })
    );
  }

  getUser(): Observable<IUserProfile> {
    return this.siteMap().pipe(
      map(x => x.user)
    );
  }
}
